module.exports = __webpack_public_path__ + "img/change-company-name.df88ee4b.svg";